<template>
  <div class="wenbox" @wheel="changeShow" @mousemove="handleMouseMove">
    <!-- <el-carousel class="wenkulist" height="100vh" @change="changecard"> -->

    <!--appear
    mode="out-in"
     name="animate__animated animate__fadeInLeft"
      :enter-active-class="animatein"
      :leave-active-class="animateout" animate__fadeInLeft -->

    <transition-group
      mode="out-in"
      class="wenkulist"
      :enter-active-class="animatein"
      :leave-active-class="animateout"
      animate__delay-1s
    >
      <div
        class="wenkuitem itemone"
        v-show="showlist[0].isShow"
        key="0"
        @click="clickshow(1)"
      >
        <div class="onecontent">
          <!-- <div class="oneimg"><img src="/static/wenku/xi.png" alt="" /></div> -->
          <div class="onetexttop"></div>
          <div class="onecontentbg">
            <div class="onepiccenter">
              <img src="/static/wenku/xi.png" alt="" />
            </div>
          </div>
          <div class="onetext">
            <div class="textleft">
              <h1 class="lefttitle">
                习近平总书记 2014年视察北大时，参观“大仓文库”中的12部珍本
              </h1>
              <p class="leftcontent">
                &nbsp;&nbsp;&nbsp;我最关心的就是中华文明历经沧桑留下的最宝贵的东西。中华民族的一些典籍在岁月侵蚀中已经失去了不少，留下来的这些瑰宝一定要千方百计呵护好，珍惜好，把我们这个世界上唯一没有中断的文明继续传承下去。让中华文明同世界各国人民创造的丰富多彩的文明一道，为人类提供正确的精神指引和强大的精神动力。
              </p>
              <p class="leftbottom">——习近平</p>
            </div>
            <div class="textright">
              <!-- <img src="/static/wenku/one1.png" alt="" /> -->
              <ul>
                <li @click="clickshow(1)">
                  <span>1912</span>
                  <div class="bar"></div>
                  <span class="space">颠沛流离</span>
                </li>
                <li @click="clickshow(2)">
                  <span>2013</span>
                  <div class="bar"></div>
                  <span class="space">回归故里</span>
                </li>
                <li @click="clickshow(6)">
                  <span>2020</span>
                  <div class="bar"></div>
                  <span class="space">重获新生</span>
                </li>
              </ul>
            </div>
            <div class="textcenter" @click="changefix">
              <img class="open" src="/static/icon/open.png" alt="" />
              <img class="logo" src="/static/wenku/logo1.png" alt="" />
            </div>
          </div>
          <!-- </div> -->
        </div>
      </div>
      <div
        class="wenkuitem itemtwo"
        v-show="showlist[1].isShow"
        key="1"
        @click="clickshow(2)"
      >
        <div class="whitebg">
          <div class="twocontent">
            <div class="twoleft">
              <div class="titlebox">
                <img src="/static/wenku/1912.png" alt="" />
                <!-- <div class="itemtwobg"></div> -->
              </div>
              <div class="contentbox">
                <p class="twotitle">颠 &nbsp;沛 &nbsp;流 &nbsp;离</p>
                <p>
                  董康身为法律名家，嗜藏书，慧眼独具，往往能够从市面上不为人关注而售价不高的古籍中，发掘出版本价值和文献价值高于普通典籍的珍本秘籍。
                  <span
                    >其“诵芬室”藏书数量之繁、种类之丰，被著名藏书家傅增湘云誉称“珍本森罗，蔚成大国”。
                  </span>
                </p>
                <br />
                <p>
                  19世纪末20世纪初，社会动荡，经济凋敝，战争频繁。1906年，陆心源皕宋楼藏书东迁日本岩崎氏静嘉堂文库，董康痛惜陆氏藏书之流散。不料，
                  <span
                    >1912年左右，旅日修读法学的他亦踵其故迹，因生计所迫，“诵芬室”藏书“悉以归诸大仓氏”。
                  </span>
                </p>
                <br />
                <p>
                  日本大仓文化财团之大仓集古馆以董康“诵芬室”藏书为基础，再加访求，<span
                    >又补入许多和刻本、朝鲜本，成为日本收藏中国典籍数量较多的机构，其藏书即“大仓藏书”。</span
                  >
                </p>
                <br />
              </div>
            </div>
            <div class="tworight">
              <img src="/static/wenku/dongkang.png" alt="" />
              <p style="margin: 15px 0">
                “古芬未坠，异域言归，反不如台城之炬、绛云之烬，魂魄犹长守故都也。”
              </p>
              <p style="text-align: right">——董康</p>
            </div>
          </div>
        </div>
        <div class="itemtwobg"></div>
      </div>
      <div
        class="wenkuitem itemthree"
        v-show="showlist[2].isShow"
        key="2"
        @click="clickshow(3)"
      >
        <div class="threecontent">
          <div class="threeleftl">
            <img src="/static/wenku/2013.png" alt="" />
          </div>
          <div class="threeleft">
            <div class="leftimg">
              <img src="/static/wenku/three1.png" alt="" />
            </div>
            <div class="lefttopt">
              <p>
                2013年12月12日，“大仓藏书”运抵北京大学图书馆善本地库，长达一年半的收购工作终于完美落幕。
              </p>
            </div>

            <p class="lefttop">
              2012年，吴小如、汤一介、吴慰慈、袁行霈、乐黛云、陈熙中、白化文、安平秋等37位学者先后签字联名建议北京大学整体收购“大仓藏书”。
            </p>
            <p class="leftbottom">
              2013年，在社会各界和政府相关部门的关注与支持下，“大仓图书”被北京大学整体回购，以“大仓文库”专藏的形式永久整体保存于北京大学图书馆。
            </p>
          </div>
          <div class="threeright">
            <div class="rightimg">
              <img src="/static/wenku/three2.png" alt="" />
            </div>
            <div class="righttext">
              <p class="righttexttitle">
                读者正在北大图书馆“大仓文库”善本展参观
              </p>
              <br />
              <br />

              <br />
              <div class="content">
                <p>
                  暌违故土近百年的珍贵古籍终于回归，这是新中国成立以来国有收藏机构首次最大规模地回购留存在海外的中国典籍。参与“大仓藏书”鉴定的学者这样评价古籍的回归：“这是一件空前的文化盛事，将会在中日文化交流史上成为令人称道的典范。”
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="itemthreebg">
          <img src="/static/wenku/2013dai3.png" />
          <!-- usemap="#Map" <div class="doc1" v-show="doc1show" @click="clickshow(1)">
            <span>.</span>1912
          </div>
          <div class="doc2" v-show="doc2show" @click="clickshow(6)">
            <span>.</span>2020
          </div>
          <map name="Map" id="Map">
            <area
              @mouseover="changeIndex(1)"
              @mouseout="changeIndex(2)"
              shape="rect"
              coords="0,728,200,858"
              href="#"
              class="doc1hover"
            />
            <area
              @mouseover="changeIndex2(1)"
              @mouseout="changeIndex2(2)"
              shape="rect"
              coords="500,628,830,770"
              href="#"
              class="doc1hover"
            />
          </map> -->
        </div>
      </div>
      <div
        class="wenkuitem itemfour"
        v-show="showlist[3].isShow"
        key="3"
        @click="clickshow(4)"
      >
        <div class="fourcontent">
          <div class="four1 dashborder">
            <img src="/static/wenku/four1.png" alt="" />
            <div class="four1text">
              <span class="title">御製天元玉曆祥異賦</span>
              <p><br />明<br />紅絲欄彩繪鈔本<br />子部</p>
            </div>
          </div>
          <div class="four2 dashborder">
            <img class="dashborder" src="/static/wenku/guang.png" alt="" />
            <div class="four2text">
              <p>
                “大仓文库”共有典籍931部，28143册，内容覆盖极广。所含藏书，覆盖“经史子集”的古籍四大部类，版本涵括刻本、活字本、钞稿本、铅印石印本、钤印本、摹刻拓本、碑拓等各种形式。
              </p>
            </div>
          </div>
          <div class="four3">
            <img src="/static/wenku/four3.png" alt="" />
            <div class="four3text">
              <p class="title">文體明辯</p>
              <p>
                <br />明萬曆間<br />
                金屬活字印本<br />
                集部
              </p>
            </div>
          </div>
          <div class="four4 dashborder">
            <img src="/static/wenku/four4.png" alt="" />
            <div class="four4text">
              <p class="title">宋拓孟蜀石經</p>
              <p>
                <br />
                <br />
                民國丙寅<br />
                影印本<br />
                經部
              </p>
            </div>
          </div>
          <div class="four5 dashborder">
            <img src="/static/wenku/55.png" alt="" />
            <div class="four5text">
              <p class="title">詩經八卷</p>
              <p>
                <br />
                日本寬政三年<br />
                刻本 經部
              </p>
            </div>
          </div>
          <div class="four6 dashborder">
            <img src="/static/wenku/four6.png" alt="" />
            <div class="four6text">
              <p class="title">鐵雲藏龜鐵雲藏陶</p>
              <p>
                <br />
                清光緒<br />
                石印本<br />
                史部
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        class="wenkuitem itemfive"
        v-show="showlist[4].isShow"
        key="4"
        @click="clickshow(5)"
      >
        <div class="fivecontent">
          <div class="five1 dashborder">
            <img src="/static/wenku/five1.png" alt="" />
            <div class="five1text">
              <p class="title">汲古閣未刻詞</p>
              <p class="titletwo"><br />清乾隆間 <br />鈔校本 <br />孤本</p>
            </div>
          </div>
          <div class="five2 dashborder">
            <img class="dashborder" src="/static/wenku/du.png" alt="" />
            <div class="five2text">
              <p>
                版本上，“大仓文库”以“独”取胜，这批藏书中有海内外现存的独一无二的孤本，如明嘉靖甲辰王准石谷书院刻本《唐十子诗》十种十四卷、明末清初钞本《南词》四十二种四十九卷《附录》三卷、清乾隆彭氏知圣道斋钞校本《汲古阁未刻词》二十二种二十四卷等。
              </p>
            </div>
          </div>
          <div class="five3 dashborder">
            <img src="/static/wenku/five3.png" alt="" />
            <div class="five3text">
              <p class="title">南詞</p>
              <p class="titletwo">
                <br />
                明末清初 <br />
                钞本孤本
              </p>
            </div>
          </div>
          <div class="five4 dashborder">
            <img src="/static/wenku/five4.png" alt="" />
            <div class="five4text">
              <p class="title">唐十子詩</p>
              <p class="titletwo"><br />明嘉靖甲辰 <br />刻本 <br />孤本</p>
            </div>
          </div>
          <div class="five5 dashborder">
            <img src="/static/wenku/five5.png" alt="" />
            <div class="five5text">
              <p class="title">字溪集</p>
              <p class="titletwo"><br />清乾隆間 <br />四庫館臣寫本</p>
            </div>
          </div>
          <div class="five6 dashborder">
            <img src="/static/wenku/five6.png" alt="" />
            <div class="five6text">
              <p class="title">东坡先生往还尺牍</p>
              <p class="titletwo">
                <br />明 <br />
                刻本 <br />
                全本
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        class="wenkuitem itemsix"
        v-show="showlist[5].isShow"
        key="5"
        @click="clickshow(6)"
      >
        <div class="sixcontent">
          <div class="six1 dashborder">
            <img src="/static/wenku/six1.png" alt="" />
            <div class="six1text">
              <p class="title">盘山志</p>
              <p class="titletwo">
                <br />
                清乾隆二十年<br />武英殿刻本<br />
                史部
              </p>
            </div>
          </div>
          <div class="six5 dashborder">
            <img src="/static/wenku/six5.png" alt="" />
            <div class="six5text">
              <p>
                <span class="title">南巡盛典</span>
              </p>
              <p class="titletwo">
                <br />

                清乾隆間 <br />四庫館寫文津閣<br />
                四庫全書本 <br />史部
              </p>
            </div>
          </div>
          <div class="six3 dashborder">
            <img src="/static/wenku/six3.png" alt="" />
            <div class="six3text">
              <p class="title">景刊唐開成石經</p>
              <p class="titletwo">
                <br />
                民國十五年 <br />皕忍堂摹刻紅印本<br />
                經部
              </p>
            </div>
          </div>
          <div class="six4 dashborder">
            <img src="/static/wenku/six4.png" alt="" />
            <div class="six4text">
              <p class="title">陽春白雪</p>
              <p class="titletwo">
                <br />
                清道光十年<br />
                錢唐瞿氏清吟閣<br />刻校樣本<br />
                集部
              </p>
            </div>
          </div>

          <div class="six2 dashborder">
            <img class="dashborder" src="/static/wenku/jing.png" alt="" />
            <div class="six2text">
              <p>
                <!-- ﹃大仓藏书文库﹄还以内容之﹃精﹄著称。得益于董康当年慧眼如炬，所选藏书不仅在文字内容上有极高的学术价值，就连藏书本身都是研究古代印刷行业的珍贵文物。 -->
                “大仓藏书文库”还以内容之“精”著称。得益于董康当年慧眼如炬，所选藏书不仅在文字内容上有极高的学术价值，就连藏书本身都是研究古代印刷行业的珍贵文物。
              </p>
            </div>
          </div>
          <div class="six6 dashborder">
            <img src="/static/wenku/six6.png" alt="" />
            <div class="six6text">
              <p class="title">古今合璧事類備要</p>
              <p class="titletwo">
                <br />明 <br />錫山安國金屬活字本 <br />子部
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="wenkuitem itemseven" v-show="showlist[6].isShow" key="6">
        <div class="sevenbk">
          <div class="sevencontent">
            <div class="sevendetail">
              <div class="sevenleft">
                <img src="/static/wenku/seven.png" alt="" />

                <p class="zhu">
                  <br />
                  出版日期：2020.06<br />
                  开本：16开 精装
                </p>
                <p class="shuoming">
                  <br /><br />
                  北京大学出版社与北京大学图书馆达成协议，对“大仓文库”文献进行开发利用。双方集合了20余位专家学者的意见，择取“大仓文库”中最具价值的<span>131种</span>典籍编为<span>《大仓文库粹编》</span>，分为<span>六大系列、228册，</span>影印出版。
                </p>
              </div>
              <div class="sevenright">
                <div class="seven1 dashborder">
                  <img src="/static/wenku/seven1.png" alt="" />
                  <div class="seven1text">
                    <p class="title">《大仓文库粹编·精善刻本》</p>
                    <p>
                      <br />
                      27种文献62册<br />
                      书号：9787301312261
                    </p>
                  </div>
                </div>

                <div class="seven2 dashborder">
                  <img src="/static/wenku/seven2.png" alt="" />
                  <div class="seven2text">
                    <p class="title">《大仓文库粹编·名家钞校本》</p>
                    <p><br />59种文献97册<br />书号：9787301312278</p>
                  </div>
                </div>
                <div class="seven3 dashborder">
                  <img src="/static/wenku/seven3.png" alt="" />
                  <div class="seven3text">
                    <p class="title">《大仓文库粹编·四庫進程本》</p>
                    <p><br />23种文献17册<br />书号:9787301312285</p>
                  </div>
                </div>
                <div class="seven4 dashborder">
                  <img src="/static/wenku/seven4.png" alt="" />
                  <div class="seven4text">
                    <p class="title">《大仓文库粹编·活字本》</p>
                    <p><br />15种文献27册<br />书号:9787301312254</p>
                  </div>
                </div>

                <div class="seven5 dashborder">
                  <img src="/static/wenku/seven5.png" alt="" />
                  <div class="seven5text">
                    <p class="title">《大仓文库粹编·和刻本·朝鲜刻本》</p>
                    <p>
                      <br />
                      4种文献14册<br />书号:9787301312308
                    </p>
                  </div>
                </div>
                <div class="seven6 dashborder">
                  <img src="/static/wenku/seven6.png" alt="" />
                  <div class="seven6text">
                    <p class="title">《大仓文库粹编·特殊印本》</p>
                    <p><br />3种文献11册<br />书号:9787301312292</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="bottomimg20">
              <div class="img20">
                <img src="/static/wenku/2020.png" alt="" />
                <div class="textcenter" @click="changefix">
                  <img class="open" src="/static/icon/open.png" alt="" />
                  <img
                    class="logo"
                    src="/static/img/logo@2x.b9e19cd.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="whitebkbottom">
            <div class="textcenter" @click="changefix">
              <div class="textcenterdiv">
                <img class="open" src="/static/icon/open.png" alt="" />
                <img
                  class="logo"
                  src="/static/img/logo@2x.b9e19cd.png"
                  alt=""
                />
              </div>
            </div>
          </div> -->
        </div>
        <div class="bottomimg">
          <!-- <p class="bottomfont1">2020</p>
          <p class="bottomfont2">重获新生</p> -->
        </div>
      </div>
    </transition-group>

    <!-- <div class="niandai">
      <ul style="display: flex">
        <li
          :class="
            activeShow == 0
              ? 'el-carousel__button actcircle'
              : 'el-carousel__button'
          "
        ></li>
        <li
          :class="
            activeShow == 1
              ? 'el-carousel__button actcircle'
              : 'el-carousel__button'
          "
        ></li>
        <li
          :class="
            activeShow == 2
              ? 'el-carousel__button actcircle'
              : 'el-carousel__button'
          "
        ></li>
        <li
          :class="
            activeShow == 3
              ? 'el-carousel__button actcircle'
              : 'el-carousel__button'
          "
        ></li>
        <li
          :class="
            activeShow == 4
              ? 'el-carousel__button actcircle'
              : 'el-carousel__button'
          "
        ></li>
        <li
          :class="
            activeShow == 5
              ? 'el-carousel__button actcircle'
              : 'el-carousel__button'
          "
        ></li>
        <li
          :class="
            activeShow == 6
              ? 'el-carousel__button actcircle'
              : 'el-carousel__button'
          "
        ></li>
      </ul>
      <span :class="this.actcard == 1 ? 'niandaiact' : ''">1912</span
      ><span :class="this.actcard > 1 && this.actcard < 6 ? 'niandaiact' : ''"
        >2013</span
      ><span :class="this.actcard == 6 ? 'niandaiact' : ''">2020</span>
    </div> -->
    <!-- :style="{
        left: actcard == 6 ? '8%' : actcard == 5 ? '50%' : '',
        transform: actcard == 5 ? 'translateX(-40%)' : '',
      }" -->
    <!-- <div class="bottomright" v-if="actcard != 0">
      <ul>
        <li @click="clickshow(1)" :class="actcard == 1 ? 'niandaiact' : ''">
          <span>1912</span>
          <div class="bar"></div>
          <span class="space">颠沛流离</span>
        </li>
        <li
          @click="clickshow(2)"
          :class="this.actcard > 1 && this.actcard < 6 ? 'niandaiact' : ''"
        >
          <span>2013</span>
          <div class="bar"></div>
          <span class="space">回归故里</span>
        </li>
        <li
          @click="clickshow(6)"
          :class="this.actcard == 6 ? 'niandaiact' : ''"
        >
          <span>2020</span>
          <div class="bar"></div>
          <span class="space">重获新生</span>
        </li>
      </ul>
    </div> -->
    <!-- <div class="srolldown" v-if="actcard == 0"> -->
    <!-- <img
        class="tobottom"
        @click="changefix"
        src="/static/newhome/icon/down1.png"
        alt=""
      /> -->
    <!-- <p @click="changefix">跳过</p>
    </div> -->
    <!-- <div class="srolldown1" v-if="actcard == 6">
      <p @click="changefix">進入大倉文庫</p>
    </div> -->
  </div>
</template>

<script>
import eventBus from '@/utils/eventBus.js'
import "animate.css"
export default {
  name: "WenKu",
  data () {
    return {
      // animatein: "animate__fadeInDown",
      // animateout: "animate__fadeOutDown",
      actcard: 0,
      animatein: "animate__fadeInLeft",
      animateout: "animate__fadeOutRight",
      headShow: false,
      activeShow: 0,//默认展示
      doc1show: false,
      doc2show: false,
      showlist: [{ isShow: true }, { isShow: false }, { isShow: false }, { isShow: false }, { isShow: false }, { isShow: false }, { isShow: false },]
    }
  },
  props: {
    isfix: false,

  },
  mounted () {
    // console.log(transheight, 'transheight')
    // this.$refs.wenkulist.style.transform='transl'
    // if (this.transheight > 0) {
    // this.$refs.wenkulist.style.transform = tranlateY("100px")
    // }

  },
  methods: {
    changeIndex (index) {
      if (index == 1) {
        this.doc1show = true
      } else {
        this.doc1show = false
      }

    },
    changeIndex2 (index) {
      if (index == 1) {
        this.doc2show = true
      } else {
        this.doc2show = false
      }

    },
    changefix (e) {
      this.$router.push('./result')
    },
    changecard (v) {
      this.actcard = v
    },
    handleMouseMove (e) {
      if (e.offsetY > 0 && e.offsetY < 100) {
        eventBus.$emit("changeShow", true)
        if (!this.headShow) {
          this.headShow = true
          eventBus.$emit("changeShow", this.headShow)
        }
      }
      if (e.offsetY > 100) {
        if (this.headShow) {
          this.headShow = false
          eventBus.$emit("changeShow", this.headShow)
        }

      }
    },
    changeShow (e) {
      if (e.wheelDelta || e.detail) {
        if (e.wheelDelta > 0 || e.detail < 0) {     //当鼠标滚轮向上滚动时
          this.animatein = "animate__animated animate__fadeInLeft"
          this.animateout = "animate__animated animate__fadeOutRight"

          if (this.activeShow > 0) {
            // this.showlist[this.activeShow].isShow = false
            this.activeShow--
            this.showlist = [{ isShow: false }, { isShow: false }, { isShow: false }, { isShow: false }, { isShow: false }, { isShow: false }, { isShow: false },]
            this.showlist[this.activeShow].isShow = true

          } else if (this.activeShow == 0) {
            this.activeShow--
            this.$router.push("/")
          }
          this.actcard = this.activeShow

        }
      }



      if (e.wheelDelta || e.detail) {
        if (e.wheelDelta < 0 || e.detail > 0) {     //当鼠标滚轮向下滚动时
          this.animatein = "animate__animated animate__fadeInRight"
          this.animateout = "animate__animated animate__fadeOutLeft"
          if (this.activeShow < 6) {
            this.activeShow++
            this.showlist = [{ isShow: false }, { isShow: false }, { isShow: false }, { isShow: false }, { isShow: false }, { isShow: false }, { isShow: false },]
            this.showlist[this.activeShow].isShow = true
            this.actcard = this.activeShow
          }

        }
      }



    },
    clickshow (val) {
      this.animatein = "animate__animated animate__fadeInRight"
      this.animateout = "animate__animated animate__fadeOutLeft"
      this.activeShow = val
      this.showlist = [{ isShow: false }, { isShow: false }, { isShow: false }, { isShow: false }, { isShow: false }, { isShow: false }, { isShow: false },]
      this.showlist[this.activeShow].isShow = true
      this.actcard = val
    }

  }

}
</script>

<style lang="less" scoped>
@import url(../../pages/newcommon.css);
.srolldown {
  position: absolute;
  // left: 50%;
  right: 20%;
  // transform: translateX(-20%);
  bottom: 20px;
  width: 100%;
  height: 70px;
  text-align: right;
  // margin-bottom: 0;
  // position: absolute;
  // left: 0;
  // bottom: 56px;
  z-index: 999999999;

  p {
    font-size: 22px;
    font-weight: 700;
    font-family: "STKaiti", serif;
    color: #cf8600;
    // width: 27px;
    // height: 48px;
    // position: absolute;
    // left: 49.85%;
    // bottom: 0;
    // position: absolute;
    cursor: pointer;
    // .tobottom {
    animation: mymovetwo 2s ease-in-out infinite;
    // }
  }
}
.srolldown1 {
  position: absolute;
  // left: 50%;
  // right: 5.5%;
  // transform: translateX(-20%);
  bottom: 3%;
  right: 20px;
  width: 100%;
  height: 70px;
  // text-align: right;
  // margin-bottom: 0;
  // position: absolute;
  // left: 0;
  // bottom: 56px;
  z-index: 999999999;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  p {
    font-size: 18px;
    font-weight: 600;
    font-family: "STKaiti", serif;
    color: #cf8600;
    letter-spacing: -2px;
    // word-spacing: 0;
    // width: 27px;
    // height: 48px;
    // position: absolute;
    // left: 49.85%;
    // bottom: 0;
    // position: absolute;
    cursor: pointer;
    // .tobottom {
    // animation: mymovetwo 2s ease-in-out infinite;
    // }
  }
}
@keyframes mymovetwo {
  // from {
  //   // top: 0px;
  //   opacity: 0;
  // }
  // to {
  //   // top: 10px;
  //   opacity: 1;
  //   transform: translateY(10px);
  // }
  0% {
    transform: translate(0, -10px);
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: translate(0, 10px);
    opacity: 0;
  }
}
/deep/.wenbox {
  transition: all 0.3s ease-in-out;
}
/deep/.niandai {
  position: absolute;
  right: 8%;
  bottom: 75px;
  color: rgb(170, 29, 31);
  font-size: 20px;
  z-index: 999999999;
  font-weight: 600;
  text-align: center;
  span {
    margin: 0 10px;
  }
  .niandaiact {
    font-size: 26px;
  }
}
/deep/.bottomright {
  position: absolute;
  right: 8.4%;
  bottom: 88px;
  z-index: 999999999;
  .niandaiact {
    font-size: 23px;
  }
  ul {
    writing-mode: vertical-lr;
    color: #cf8600;
    font-size: 20px;
    font-weight: 800;
    font-family: "STKaiti", serif;
    // display: flex;
    li {
      width: 80px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      margin-left: 22px;
      cursor: pointer;
    }
  }
  .space {
    letter-spacing: -10px;
  }
  .bar {
    width: 1px;
    height: 60px;
    background: #000;
  }
}
/deep/.el-carousel__indicators {
  z-index: 999999999;
}
/deep/.el-carousel__indicators--horizontal {
  left: 85%;
  bottom: 30px;
  transform: none;
}
/deep/.el-carousel__button {
  width: 12px;
  height: 12px;
  margin: 10px;
  border-radius: 50%;
  background-color: transparent;
  border: 2px solid rgb(170, 29, 31);
}
/deep/.actcircle {
  width: 14px;
  height: 14px;
  border: 3px solid rgb(170, 29, 31);
}
/deep/.el-carousel__indicator--horizontal {
  padding: 12px 10px;
}
html {
  font-size: 16px;
}
.fix {
  // padding-top: 100px;
  position: absolute;
  top: 0px;
}
.wenkulist {
  font-family: "STKaiti", serif;
  font-size: 16px;
  letter-spacing: 2px;
  text-align: justify;
  width: 100vw;
  height: 100vh;
  min-width: 1500px;
  overflow: hidden;
  z-index: 999;
  position: absolute;
  top: 0px;

  .wenkuitem {
    width: 100%;
    height: 100%;

    overflow: hidden;
    position: absolute;
    top: 0px;
    left: 0px;
    background-color: #fff;
    // height: 67.56rem;
    // height: 100%;
  }
  .title {
    font-size: 22px;
  }
  .titletwo {
    font-size: 18px;
  }
  .itemone {
    background: url("/static/wenku/bg12.png") no-repeat scroll center;
    background-size: 100% 100%;
    // padding-top: 211.2px;
    // padding-top: 11%;
    // padding-left: 160px;
    z-index: 99;
    // position: relative;
    display: flex;
    align-items: center;

    .onecontentbg {
      width: 100%;
      height: 546px;
      background: url("/static/wenku/bg111.png") no-repeat scroll center;
      background-size: 100% 100%;
      // background-position: 0 247px;
      // display: flex;
      // justify-content: center;
      // align-items: center;
    }
    .onecontent {
      width: 100%;
      height: 950px;
      // margin:0 auto;
      // margin-left: 8%;
      // position: absolute;
      // left: 8%;
      // bottom: 20px;
      // top: 18.5rem;
      // height: 100%;

      // flex-direction: column;
      // justify-content: space-between;
      .onetexttop {
        width: 1500px;
        // height: 18.4rem;
        height: 240px;
        background: url("/static/wenku/top1.png") no-repeat scroll center;
        background-size: 100% 100%;
        margin: 0 auto;
      }
      .onepiccenter {
        width: 1500px;
        height: 546px;
        margin: 0 auto;
        img {
          width: 570px;
          height: 546px;
        }
      }
    }
    .oneimg {
      width: 490px;
      height: 477px;
      // width: 50%;
      // height: 67%;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .onetext {
      width: 1500px;
      // height: 272px;
      // height: 7.2rem;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      // align-items: flex-end;
      align-items: center;
      .textleft {
        // width: 490px;
        width: 574px;
        font-family: "STKaiti", serif;
        color: #000;
        .lefttitle {
          //font-size: 1.1vh;
          font-size: 12px;
          font-weight: normal;
          font-weight: 700;
          color: #1c2127;
        }
        .leftcontent {
          // font-size: 1.67vh;
          margin-top: 10px;
          font-size: 16px;
          font-weight: 700;
          color: #000d00;
        }
        .leftbottom {
          // margin-top: 10px;
          font-size: 18px;
          font-weight: 700;
          color: #000d00;
          text-align: right;
        }
      }
      .textright {
        width: 480px;
        height: 110px;
        // margin-top: 0.8rem;
        // flex: 1;
        // margin-left: 160px;
        // img {
        //   width: 333px;
        //   height: 101px;
        //   margin-top: 96px;
        //   // margin-left: 5rem;
        // }
        ul {
          width: 100%;
          height: 100%;
          writing-mode: vertical-lr;
          color: #cf8600;
          font-size: 26px;
          font-weight: 800;
          font-family: "STKaiti", serif;
          // display: flex;
          li {
            width: 106px;
            // height: 100;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
            margin-left: 50px;
            cursor: pointer;
          }
        }
        .space {
          letter-spacing: -10px;
        }
        .bar {
          width: 1px;
          height: 90px;
          background: #000;
        }

        // margin-bottom: 2.8rem;
      }
      .textcenter {
        width: 280px;
        // height: 44px;
        // line-height: 44px;
        margin-right: -153px;
        margin-top: 60px;
        display: flex;
        align-items: center;
        cursor: pointer;
        .open {
          width: 30px;
          height: auto;
          margin-right: 18px;
          margin-top: 2px;
          // float: left;
          // img {
          //   width: 100%;
          //   height: auto;
          // }
        }
        .logo {
          // width: 100%;
          // height: 100%;
          width: 200px;
          height: auto;
        }
      }
    }
  }
  .itemtwo {
    background: url("/static/newhome/bg.jpg") no-repeat scroll center;
    background-size: 100% 100%;
    // padding: 70px 88px;
    font-family: "STKaiti", serif;
    // margin-top: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    // position: relative;
    .itemtwobg {
      width: 100%;
      height: 100%;
      background: url("/static/wenku/sidai.png") no-repeat;
      background-position: -20px 36%;
      position: absolute;
      left: 0;
      top: 0;
    }

    font-weight: 700;
    z-index: 999;
    .whitebg {
      width: 95%;
      height: 90%;
      min-width: 1500px;
      min-height: 860px;
      display: flex;
      justify-content: center;
      align-items: center;

      background-color: #fff;
      .twocontent {
        width: 1500px;
        height: 860px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
      }

      .twoleft {
        margin-top: 270px;
        width: 960px;
        font-size: 22px;
        color: #000800;
        .titlebox {
          width: 100%;
          height: 100px;
          position: relative;

          // background: url("/static/wenku/sidai.png") no-repeat;
          // background-position: -120px 0;
          // padding-left: 88px;
          position: relative;
          font-size: 130.08px;
          color: #9a0000;
          line-height: 154.4px;
          span {
            position: absolute;
            left: 64px;
            top: -56px;
          }
          img {
            width: 268px;
            height: 94.5px;
            margin-bottom: 40px;
            position: absolute;
            bottom: -10px;
          }
        }
        .contentbox {
          width: 710px;
          // padding-left: 88px;
        }
        .twotitle {
          font-size: 36px;
          color: #9a0000;
          padding: 0;
          margin: 10px 0 18px;
          // line-height: 2;
        }
        span {
          color: #9a0000;
        }
      }
      .tworight {
        width: 417px;
        height: 563px;
        margin-top: 60px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .itemthree {
    margin: 0 auto;
    background: url("/static/wenku/2013bg.png") no-repeat scroll center;
    background-size: 100% 100%;
    font-size: 20px;
    font-weight: 500;
    color: #fffbff;
    letter-spacing: 0.5px;
    z-index: 9999;
    display: flex;
    align-items: center;
    position: relative;
    .itemthreebg {
      width: 100%;
      height: 100%;
      // background: url("/static/wenku/2013dai3.png") no-repeat;
      // background-position: 0 5px;
      // background-size: 100% 100%;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 1;
      // display: flex;
      // justify-content: space-between;
      color: rgb(170, 29, 31);
      font-size: 30px;
      font-weight: 700;
      .doc1 {
        font-family: "FZCuSong-B09S	";
        position: absolute;
        left: 40px;
        top: 730px;
        display: flex;
        flex-direction: column;
        text-align: center;
        span {
          font-size: 48px;
        }
      }
      .doc2 {
        font-family: "FZCuSong-B09S	";
        position: absolute;
        left: 630px;
        top: 650px;
        display: flex;
        flex-direction: column;
        text-align: center;
        span {
          font-size: 48px;
        }
      }
      .doc1hover:hover + .doc1 {
        display: block;
      }
    }

    .threecontent {
      width: 1500px;
      height: 860px;
      margin: 0 auto;
      // padding: 50px 25px 0;
      display: flex;
      justify-content: space-between;
    }
    .threeleftl {
      flex: 1;
      height: 100%;
      margin-right: 200px;
      position: relative;

      img {
        width: 100%;
        height: 240px;
        // margin-top: 600px;
        position: absolute;
        bottom: 0;
        left: 0;
        z-index: -2;
      }
    }
    .threeleft {
      width: 402px;
      margin-right: 68px;
      z-index: 2;
      .lefttopt {
        width: 95%;
        margin: 30px 0px 0 240px;
      }
      .leftimg {
        margin-top: 30px;
        width: 402px;
        height: 275px;
        opacity: 0.85;
      }
      p {
        padding: 0;
        margin: 0;
      }
      .lefttop {
        width: 51%;
        // margin-top: 10px;
        margin-left: -80px;
      }
      .leftbottom {
        margin-top: -80px;
        width: 50%;
        float: right;
      }
    }
    .threeright {
      width: 500px;
      z-index: 2;
      // margin-right: 55px;
      .rightimg {
        width: 100%;
        height: 275px;
        margin-top: 30px;
        line-height: 275px;
        img {
          width: 450px;
          height: 270px;
          margin-top: 3px;
          // margin-right: 40px;
          opacity: 0.85;
        }
      }
      .righttext {
        width: 100%;
        // margin-top: 10px;
        .righttexttitle {
          font-size: 12px;
          // text-align: right;
          margin-left: 200px;
        }
        .content {
          width: 286px;
          margin-left: 210px;
        }
      }
    }
  }
  .itemfour {
    // background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    background: url("/static/wenku/guangbg.png") no-repeat scroll center;
    background-size: 100% 100%;
    background-position: 0px -25px;

    .fourcontent {
      z-index: 99999;
      max-width: 1500px;
      // height: 95vh;
      height: 910px;
      margin: 0 auto;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: bottom;
      align-content: space-between;
      font-size: 18px;
      // font-family: "SimHei";
      font-family: "Adobe Heiti Std", "Microsoft YaHei", Arial, sans-serif;
      font-weight: 700;
      color: #fff;
    }
    .title {
      font-size: 22px;
    }
    .four1 {
      width: 465px;
      height: 330px;

      // width: 23vw;
      // height: auto;
      // position: absolute;
      // top: 3.63rem;
      // left: 9.88rem;
      // margin: -2px;
      position: relative;
      // img {
      //   width: 100%;
      //   height: auto;
      // }

      .four1text {
        width: 238px;
        height: 150px;
        // background-color: #a0a0a0;
        background-color: rgba(161, 161, 161, 0.52);
        // opacity: 0.4;
        position: absolute;
        padding: 16px 0 16px 16px;
        bottom: 0;
        left: 0;
      }
    }
    .four2 {
      width: 374px;
      height: 434px;
      // border: 2px dashed #ccc;
      // position: absolute;
      // top: 3.63rem;
      // left: 49.25em;
      position: relative;
      background: url("/static/wenku/zibg1.png") no-repeat center;
      background-size: 374px 434px;
      // background-position: 5rem 5rem;
      img {
        width: 155px;
        height: 175px;
        position: absolute;
        top: 130px;
        left: 72px;
      }

      .four2text {
        width: 245px;
        // height: 114px;
        letter-spacing: 0;
        font-size: 16px;
        font-family: FZBSK;
        font-weight: normal;
        color: #250d00;
        line-height: 22px;
        position: absolute;
        top: 230px;
        left: 212px;
      }
    }
    .four3 {
      width: 390px;
      height: 548px;
      // width: 19vw;
      // height: auto;
      // position: absolute;
      // top: 3.63rem;
      // left: 84.19rem;
      position: relative;

      .four3text {
        width: 100%;
        height: 200px;
        background-color: rgba(161, 161, 161, 0.52);
        padding: 22.4px;
        position: absolute;
        bottom: 0;
        left: 0;
      }
    }
    .four4 {
      width: 402px;
      height: 554px;

      // position: absolute;
      // left: 9.94rem;
      // top: 27.63em;
      position: relative;
      margin-top: -236px;

      .four4text {
        width: 100%;
        height: 212px;
        background-color: rgba(161, 161, 161, 0.52);
        position: absolute;
        padding: 48px 22.4px 0;
        bottom: 0;
      }
    }
    .four5 {
      width: 492px;
      height: 303px;
      // margin-top: 3rem;
      // position: absolute;
      // left: 39.816px;
      // top: 44.25em;
      position: relative;

      .four5text {
        width: 340px;
        height: 130px;
        background-color: rgba(161, 161, 161, 0.52);
        position: absolute;
        padding: 16px 22px;
        bottom: 0;
        left: 0;
      }
    }
    .four6 {
      width: 508px;
      height: 302px;
      // margin-top: 3rem;
      // position: absolute;
      // left: 76.25rem;
      // top: 44.25em;
      position: relative;
      align-self: bottom;

      .four6text {
        width: 137px;
        height: 288px;
        background-color: rgba(161, 161, 161, 0.52);
        position: absolute;
        padding: 20px;
        top: 0;
        right: 0;
      }
    }
  }
  .itemfive {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: url("/static/wenku/dubg.png") no-repeat scroll center;
    background-size: 100% 100%;
    background-position: 0px -20px;
    .fivecontent {
      z-index: 999999;
      // width: 1500px;
      max-width: 1500px;
      height: 910px;
      margin: 0 auto;
      // height: 100vh;
      // margin-bottom: 10rem;
      // padding: 3.63rem 9.88rem;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-content: space-between;
      // position: relative;
      font-size: 20px;
      font-family: Adobe Heiti Std;
      font-weight: 700;
      color: #fff;
    }
    .five1 {
      width: 392px;
      height: 542px;
      // position: absolute;
      // top: 3.63rem;
      // left: 9.88rem;
      position: relative;

      .five1text {
        width: 180px;
        height: 278px;
        background-color: rgba(161, 161, 161, 0.52);
        position: absolute;
        padding: 65px 16px 0;
        top: 158px;
        right: 0;
      }
    }
    .five2 {
      width: 374px;
      height: 434px;
      // border: 2px dashed #ccc;
      // position: absolute;
      // top: 3.63rem;
      // left: 49.25em;
      margin-left: -280px;
      margin-top: -73px;
      position: relative;
      background: url("/static/wenku/zibg222.png") no-repeat 50px, center;
      background-size: 236px 245px;

      // background-position: 0rem 10px;
      img {
        width: 158px;
        height: 152px;

        position: absolute;
        top: 140px;
        left: 145px;
      }
      .five2text {
        position: absolute;
        top: 184px;
        left: 316px;
        letter-spacing: 0;
        width: 320px;
        height: 114px;
        font-size: 16px;
        font-family: FZBSK;
        font-weight: normal;
        color: #250d00;
        line-height: 22px;
      }
    }
    .five3 {
      width: 442px;
      height: 393px;
      // position: absolute;
      // top: 3.63rem;
      // left: 84.19rem;
      position: relative;

      .five3text {
        width: 219px;
        height: 190px;
        text-align: center;
        background-color: rgba(161, 161, 161, 0.52);
        position: absolute;
        padding: 50px 16px 0px;
        top: 105px;
        right: 0;
      }
    }
    .five4 {
      width: 582px;
      height: 291px;
      // position: absolute;
      // left: 9.94rem;
      // top: 27.63em;
      margin-top: -20px;
      position: relative;

      .five4text {
        width: 182px;
        height: 100%;
        background-color: rgba(161, 161, 161, 0.52);
        position: absolute;
        padding: 80px 0 0 36px;
        top: 0;
        right: 0;
      }
    }
    .five5 {
      width: 404px;
      height: 543px;
      margin-top: -265px;
      margin-left: -60px;
      // position: absolute;
      // left: 39.816px;
      // top: 44.25em;
      position: relative;

      .five5text {
        width: 185px;
        height: 288px;
        background-color: rgba(161, 161, 161, 0.52);
        position: absolute;
        padding: 160px 0 0 16px;
        top: 72px;
        left: 0;
      }
    }
    .five6 {
      width: 370px;
      height: 432px;
      margin-top: -160px;
      // position: absolute;
      // left: 76.25rem;
      // top: 44.25em;
      position: relative;

      .five6text {
        width: 255px;
        height: 172px;
        background-color: rgba(161, 161, 161, 0.52);
        position: absolute;
        padding: 20px 0 0 20px;
        bottom: 0;
        left: 0;
      }
    }
  }

  .itemsix {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: url("/static/wenku/jingbg1.png") no-repeat scroll center;
    background-size: 100% 100%;
    background-position: 0px 10px;
    .sixcontent {
      z-index: 9999999;
      // width: 1500px;
      max-width: 1500px;
      height: 910px;
      margin: 0 auto;
      // height: 100vh;
      // padding: 3.63rem 9.88rem;
      // padding-top: 20px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: bottom;
      align-content: top;
      // position: relative;
      font-size: 20px;
      font-family: Adobe Heiti Std;
      font-weight: 700;
      color: #fff;
    }

    .six1 {
      width: 465px;
      height: 551px;
      // position: absolute;
      // top: 3.63rem;
      // left: 9.88rem;
      position: relative;

      .six1text {
        width: 167px;
        height: 284px;
        background-color: rgba(161, 161, 161, 0.52);
        // background-color: rgba(166, 159, 150, 0.6);
        // background-color: #a69f96;
        position: absolute;
        padding: 95px 0 0 25px;
        top: 170px;
        right: 0;
      }
    }
    .six2 {
      width: 379px;
      height: 438px;
      // border: 2px dashed #ccc;
      margin-top: -230px;
      // margin-left: 96px;
      // position: absolute;
      // top: 3.63rem;
      // left: 49.25em;
      position: relative;
      background: url("/static/wenku/zibg3.png") no-repeat center;
      background-size: 373px 434px;
      // background-position: 5rem 5rem;
      img {
        width: 155px;
        height: 175px;
        position: absolute;
        top: 155px;
        left: 50px;
      }

      .six2text {
        width: 150px;
        // height: 340px;
        letter-spacing: 1px;
        font-size: 16px;
        font-family: FZBSK;
        // writing-mode: vertical-rl;
        font-weight: normal;
        color: #00325b;
        line-height: 24px;
        position: absolute;
        top: 260px;
        left: 215px;
      }
    }
    .six3 {
      width: 340px;
      height: 465px;
      // position: absolute;
      // top: 3.63rem;
      // left: 84.19rem;
      position: relative;

      .six3text {
        width: 100%;
        height: 163px;
        background-color: rgba(161, 161, 161, 0.52);
        position: absolute;
        padding: 10px 0 0 20px;
        bottom: 0;
        left: 0;
      }
    }
    .six4 {
      width: 467px;
      height: 327px;
      margin-top: 10px;
      // position: absolute;
      // left: 9.94rem;
      // top: 27.63em;
      position: relative;

      .six4text {
        width: 195px;
        height: 213px;
        background-color: rgba(161, 161, 161, 0.52);
        position: absolute;
        padding: 16px 0 0 20px;
        bottom: 0;
        left: 0;
      }
    }
    .six5 {
      width: 606px;
      height: 380px;
      // position: absolute;
      // left: 39.816px;
      // top: 44.25em;
      position: relative;

      .six5text {
        width: 100%;
        height: 163px;
        background-color: rgba(161, 161, 161, 0.52);
        position: absolute;
        padding: 8px 0 0 35px;
        bottom: 0;
        left: 0;
      }
    }
    .six6 {
      width: 509px;
      height: 365px;
      // position: absolute;
      // left: 76.25rem;
      // top: 44.25em;
      position: relative;
      margin-top: -30px;

      .six6text {
        width: 230px;
        height: 100%;
        background-color: rgba(161, 161, 161, 0.52);
        position: absolute;
        padding: 220px 0 0 20px;
        bottom: 0;
        right: 0;
      }
    }
  }
  .itemseven {
    z-index: 99999999;
    background: url("/static/newhome/bg.jpg") no-repeat scroll center;
    background-size: 100% 100%;
    // padding: 54px 69px;
    font-family: "STKaiti", serif;
    display: flex;
    justify-content: center;
    align-items: center;
    letter-spacing: 1px;
    .sevenbk {
      width: 97%;
      min-width: 1500px;
      height: 93%;
      background-color: #fff;
      display: flex;
      align-items: center;
      position: relative;
      .whitebkbottom {
        // width: 200px;
        // position: absolute;
        // right: 0;
        // bottom: 20px;
        // z-index: 1;
        // cursor: pointer;
        // background-color: pink;
        width: 1500px;
        height: 100%;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 0px;
      }
    }
    .sevencontent {
      width: 1500px;
      height: 830px;
      position: relative;

      margin: 0 auto;
      // padding: 0 54px 0 90px;

      .sevendetail {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: space-between;
        align-content: bottom;
      }
    }
    .bottomimg20 {
      width: 278px;
      // height: 251px;
      // background: url("/static/wenku/2020.png") no-repeat center;
      // background-size: 100% 100%;
      z-index: 10;
      position: absolute;
      right: 0;
      bottom: 38px;
      // display: flex;
      // flex-direction: column;
      // justify-content: space-between;
      .img20 {
        width: 278px;
        height: 151px;
        margin-bottom: 50px;
      }
      .textcenter {
        width: 100%;
        // height: 100%;
        padding: 10px 0;
        margin-top: 10px;
        // height: 44px;
        // line-height: 44px;
        // margin-right: -153px;
        // margin-top: 60px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        cursor: pointer;
        // margin-bottom: 10px;
        // .textcenterdiv {
        //   width: 200px;
        //   display: flex;
        //   align-items: center;
        //   justify-content: flex-end;
        // }
        .open {
          width: 22px;
          height: auto;
          margin-right: 16px;
          margin-top: 3px;

          // float: left;
          // img {
          //   width: 100%;
          //   height: auto;
          // }
        }
        .logo {
          // width: 100%;
          // height: 100%;
          width: 140px;
          height: auto;
        }
      }
    }
    .bottomimg {
      // width: 41.4vw;
      // height: 38vh;
      width: 801px;
      height: 346px;
      background: url("/static/wenku/2020dai.png") no-repeat center;
      background-size: 100% 100%;
      position: absolute;
      right: 0;
      bottom: 0;
      p {
        margin: 0;
      }
      .bottomfont1 {
        font-size: 130px;
        font-family: "FZCSK--GBK1-0";
        font-weight: normal;
        color: #9a0000;
        // line-height: 154px;
      }
      .bottomfont2 {
        font-size: 36px;
        font-family: "FZCSK--GBK1-0";
        font-weight: normal;
        color: #9a0000;
        // line-height: 62px;
      }
    }
    .sevenleft {
      width: 452px;
      padding-top: 60px;
      margin: 0 auto;

      img {
        width: 416px;
        height: 416px;
        // margin-left: 50px;
      }
      .zhu {
        font-size: 16px;
        font-weight: 600;
        color: #000000;
        line-height: 18px;
        text-align: left;
      }
      .shuoming {
        text-align: justify;
        font-size: 20px;
        font-weight: 600;
        color: #000b00;
        span {
          color: #9a0000;
        }
      }
    }
    .sevenright {
      width: 1050px;
      height: 855px;
      margin: 0px auto;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: bottom;
      align-content: top;
      color: #fff;
      font-size: 14px;
      font-weight: 500;
      .title {
        font-size: 16px;
        color: #9a0000;
        font-weight: 600;
      }

      .seven1 {
        width: 293px;
        height: 300px;
        position: relative;
        transform: translate(120px, 30px);
        z-index: 9;

        .seven1text {
          width: 283px;
          height: 122px;
          background-color: rgba(161, 161, 161, 0.52);
          position: absolute;
          padding: 10px 5px;
          bottom: 0;
          left: 0;
        }
      }
      .seven2 {
        width: 357px;
        height: 314px;
        // margin-top: 120px;
        transform: translateY(60%);
        margin-left: -10px;
        z-index: 5;
        position: relative;

        .seven2text {
          width: 345px;
          height: 140px;
          background-color: rgba(161, 161, 161, 0.52);
          position: absolute;
          padding: 16px;
          bottom: 30px;
          left: 0;
        }
      }
      .seven3 {
        width: 313px;
        height: 290px;
        // width: 164px;
        // height: 282px;
        // position: absolute;
        // top: 3.63rem;
        // left: 84.19rem;
        z-index: 6;
        img {
          width: 170px;
          height: 290px;
        }
        position: relative;
        transform: translateX(-230px);

        .seven3text {
          width: 178px;
          height: 280px;
          // background-color: #a1a1a1;
          background-color: rgba(161, 161, 161, 0.52);

          position: absolute;
          padding: 16px 2px;
          top: 5px;
          left: 136px;
        }
      }
      .seven4 {
        width: 320px;
        height: 306px;
        position: relative;
        transform: translate(60px, -80px);
        z-index: 4;
        .seven4text {
          width: 155px;
          height: 300px;
          background-color: rgba(161, 161, 161, 0.52);
          position: absolute;
          padding: 10px 5px;
          bottom: 3px;
          left: 0;
        }
      }
      .seven5 {
        width: 329px;
        height: 260px;
        // position: absolute;
        // left: 39.816px;
        // top: 44.25em;
        position: relative;
        transform: translate(-110px, 76px);
        img {
          width: 335px;
          height: 264px;
        }

        .seven5text {
          width: 215px;
          height: 256px;
          background-color: rgba(161, 161, 161, 0.52);
          // background-color: #a1a1a1;
          position: absolute;
          padding: 60px 0 0 10px;
          bottom: 0px;
          left: 310px;
        }
      }
      .seven6 {
        width: 350px;
        height: 289px;
        // position: absolute;
        // left: 76.25rem;
        // top: 44.25em;
        position: relative;
        transform: translate(-10px, -180px);
        z-index: 6;

        .seven6text {
          width: 345px;
          height: 164px;
          background-color: rgba(161, 161, 161, 0.52);
          position: absolute;
          padding: 16px 5px;
          top: 40px;
          left: 0;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/wenku/index.vue